// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Qe7mb","content":"style_content__TAq4O","icon":"style_icon__MX_CT","custom-button-style":"style_custom-button-style__NUJ96"};